import { ButtonHTMLAttributes } from "react";
import { ButtonWrapper } from "./styled";
import { LoadingOutlined } from "@ant-design/icons";

type ButtonProps = {
  primary?: boolean;
  secondary?: boolean;
  textButton?: boolean;
  loading?: boolean;
}
function Button({
  children,
  type,
  onClick,
  primary,
  secondary,
  textButton,
  disabled,
  loading,
  autoFocus,
  style,
}: ButtonHTMLAttributes<HTMLButtonElement> & ButtonProps) {
  const getClassName: () => string = () => {
    let className: string = "";
    if (primary) className += " primaryButton"
    if (secondary) className += " secondaryButton"
    if (textButton) className += " textButton"
    if (disabled) className += " buttonDisabled"
    return className.trim();
  }
  return (
  <ButtonWrapper
    type={type}
    onClick={onClick}
    className={getClassName()}
    disabled={disabled || loading}
    style={style}
    autoFocus={autoFocus}
  >
    {loading && <LoadingOutlined style={{ marginRight: 10 }} spin/>}{children}
  </ButtonWrapper>
  )
}

export default Button;
